import { danger, infoColor, NA, pending, rejected, success, warningColor } from "./Constant";

export const getStatus = (statusValue: string) => {
  if (statusValue?.toLowerCase() === NA) {
    return infoColor;
  }

  if (statusValue?.toLowerCase() === pending) {
    return warningColor;
  }
  if (statusValue?.toLowerCase() === rejected) {
    return danger;
  }

  if (statusValue?.toLowerCase() === success) {
    return success;
  }
  return infoColor;
};
